<template>
  <div
    v-if="showTrustPilotWidget"
    class="w-full px-5 lg:py-10"
  >
    <ClientMobileOnly>
      <Trustbox
        :template-id="TRUSTPILOT_WIDGET_MINI_CAROUSEL_ID"
        :style-height="TRUSTPILOT_MINI_CAROUSEL_WIDGET_HEIGHT"
        :locale="languageAndCountry"
        :review-languages="language"
        :stars="TRUSTPILOT_CAROUSEL_STARS_RATING"
        class="lg:hidden w-full"
      />
    </ClientMobileOnly>
    <ClientDesktopOnly>
      <Trustbox
        :template-id="TRUSTPILOT_WIDGET_CAROUSEL_ID"
        :style-height="TRUSTPILOT_CAROUSEL_WIDGET_HEIGHT"
        :locale="languageAndCountry"
        :review-languages="language"
        :stars="TRUSTPILOT_CAROUSEL_STARS_RATING"
        class="w-full hidden lg:block"
      />
    </ClientDesktopOnly>
  </div>
</template>

<script lang="ts">


import { TRUSTPILOT_CAROUSEL_WIDGET_HEIGHT, TRUSTPILOT_MINI_CAROUSEL_WIDGET_HEIGHT } from '~~/constants/ui';
import {
  TRUSTPILOT_CAROUSEL_STARS_RATING,
  TRUSTPILOT_WIDGET_CAROUSEL_ID,
  TRUSTPILOT_WIDGET_MINI_CAROUSEL_ID,
} from '~~/constants/trustPilot';

export default defineComponent({
  name: 'TrustPilotCarousel',
  setup() {

    const { languageAndCountry, language } = useLocalization();
    const { showTrustPilotWidget } = useTrustPilotWidget();

    return {
      languageAndCountry,
      TRUSTPILOT_CAROUSEL_WIDGET_HEIGHT,
      TRUSTPILOT_MINI_CAROUSEL_WIDGET_HEIGHT,
      TRUSTPILOT_CAROUSEL_STARS_RATING,
      TRUSTPILOT_WIDGET_CAROUSEL_ID,
      TRUSTPILOT_WIDGET_MINI_CAROUSEL_ID,
      showTrustPilotWidget,
      language,
    };
  
  },
});

</script>
